

































































































































































































































































import moment from "moment";
import Vue from "vue";

// Vue components
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";
import InstallationStatusTableHeaderFilter from "@/components/InstallationStatusTableHeaderFilter.vue";
import BranchFilter from "@/components/TableHeaderFilters/BranchFilter.vue";
import DateRangeFilter from "@/components/TableHeaderFilters/DateRangeFilter.vue";
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import DeviceModelChip from "@/views/App/Components/chips/DeviceModelChip.vue";
import GlobalStatusInstallationChip from "@/views/App/Components/chips/GlobalStatusInstallationChip.vue";
import BagFullPercent from "./BagFullPercent.vue";
import InstallationContentDetails from "./InstallationContentDetails.vue";

// Model
import { InstallationContent } from "@/model/data/content/InstallationContent";
import { MachineContent } from "@/model/data/content/MachineContent";
import { StockTypeEnum } from "@/model/data/enums/StockTypeEnum";
import { Machine } from "@/model/data/Machine";
import { dataTableItemsPerPage } from "@/utility/Constants";
import { formatCurrency } from "@/utility/Formatter";

export default Vue.extend({
    components: {
        TableFiltersRow,
        GlobalStatusInstallationChip,
        InstallationContentDetails,
        DeviceModelChip,
        BagFullPercent,
        ColumnVisibilityFilter,
    },
    data() {
        return {
            moment,
            StockTypeEnum,
            dataTableItemsPerPage,
            options: {},
            notSupportedBagModels: ["DropVault"],
            ignoreOptionsChanges: false,
            availableHeaders: [],
            initialAvailableHeaders: [
                {
                    enabled: true,
                    text: this.$t("common.installationStatus"),
                    value: "status",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("common.name"),
                    value: "name",
                },
                {
                    enabled: true,
                    text: this.$t("common.branch"),
                    value: "branch.name",
                },
                {
                    enabled: true,
                    text: this.$t("common.tags"),
                    value: "tags",
                },
                { enabled: false, text: this.$t("common.agent_ip"), value: "agentInfo.ip" },
                {
                    enabled: false,
                    text: this.$t("device_status.pc_name"),
                    value: "connectedPc",
                },
                {
                    enabled: false,
                    text: this.$t("common.last_update"),
                    value: "lastMessage",
                    width: "120px",
                },
                {
                    enabled: false,
                    text: this.$t("common.last_agent_message"),
                    value: "agentInfo.lastMessage",
                    sortable: true,
                    width: "120px",
                },
                {
                    enabled: true,
                    text: this.$t("deviceContent.totalAmount"),
                    value: "installationAmount",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: "",
                    value: "divider",
                    sortable: false,
                    width: "1",
                },
                {
                    enabled: true,
                    text: this.$t("common.device/s"),
                    value: "machines",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("deviceContent.deviceAmount"),
                    value: "deviceAmount",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("deviceContent.deviceAvailability"),
                    value: "deviceAvailability",
                    sortable: false,
                },
                {
                    enabled: false,
                    text: this.$t("deviceContent.virtualSafeContent"),
                    value: "virtualSafeContent",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("deviceContent.bagFullPercent"),
                    value: "bagFullPercent",
                    sortable: false,
                    align: "center",
                },
                {
                    enabled: true,
                    text: this.$t("deviceContent.thresholdAlerts"),
                    value: "thresholdAlerts",
                    sortable: false,
                    align: "center",
                },
                {
                    enabled: false,
                    text: this.$t("deviceContent.machineBags"),
                    value: "machineBags",
                    sortable: false,
                    width: "200px",
                },
            ],
            filters: [
                {
                    headerValue: "status",
                    filterKey: "globalStatusFilter",
                    component: InstallationStatusTableHeaderFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "branch.name",
                    filterKey: "branchNames",
                    component: BranchFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "lastMessage",
                    filterKey: "installationLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_installation_message") }),
                },
                {
                    headerValue: "agentInfo.lastMessage",
                    filterKey: "agentLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_agent_message") }),
                },
            ],
        };
    },
    props: {
        loading: { required: true, type: Boolean },
        paginatedTotalItems: Number,
        installations: { required: true, type: Array },
    },
    watch: {
        options: {
            handler(newOptions) {
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },
    },
    methods: {
        formatCurrency,

        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
                console.debug("backToTheFirst, this.options: ", this.options);
            }
        },

        getModelFromSerialNumber(serialNumber: string): string {
            console.log("getModelFromSerialNumber, serial number required: ", serialNumber);
            let modelString: string = "";

            this.installations.forEach((inst: InstallationContent) => {
                inst.machines.forEach((machine: Machine) => {
                    if (machine.serialNumber == serialNumber) {
                        console.log("getModelFromSerialNumber, model FOUND: ", machine.model);

                        return machine.model;
                    }
                });
            });

            return modelString;
        },

        getMachineContentFromMachine(installation: InstallationContent, serialNumber: string) {
            let res: MachineContent = new MachineContent();
            if (installation.contentMachines != null && installation.contentMachines.filter((mc: MachineContent) => mc.machineSerialNumber == serialNumber).length > 0)
                res = installation.contentMachines.filter((mc: MachineContent) => mc.machineSerialNumber == serialNumber)[0];
            return res;
        },
        getTotalQuantityInBag(installation: InstallationContent, serialNumber: string) {
            let machineContent = this.getMachineContentFromMachine(installation, serialNumber);
            if (machineContent && machineContent.content) return machineContent.content.totalQuantityInBag();
            return 0;
        },
        getVirtualSafeContentTotals(installation: InstallationContent) {
            let res: Map<string, number> = new Map<string, number>();
            if (installation.virtualSafeContent && installation.virtualSafeContent.content && installation.virtualSafeContent.content.length > 0) {
                installation.virtualSafeContent.content.forEach((content) => {
                    if (!res.get(content.denomination.currency)) {
                        res.set(content.denomination.currency, 0);
                    }
                    res.set(content.denomination.currency, res.get(content.denomination.currency) + content.denomination.value * content.quantity);
                });
            }
            return res;
        },
        getMachineBagFillingPercentage(installation: InstallationContent, serialNumber: string) {
            if (
                installation &&
                installation.machinesBagFillingPercentage &&
                installation.machinesBagFillingPercentage.size &&
                installation.machinesBagFillingPercentage.has(serialNumber)
            )
                return installation.machinesBagFillingPercentage.get(serialNumber);
            return null;
        },
    },
});
